import { createFileRoute, redirect } from "@tanstack/react-router";

/** Moments live in the Notebook now; old links still land somewhere useful. */
export const Route = createFileRoute("/_authenticated/me/moments")({
  beforeLoad: () => {
    throw redirect({ to: "/me/notebook" });
  },
});
